export default "__VITE_ASSET__pYjnzNSh__"